import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './gaurd/auth.guard';
import { RatingBodyType } from './gaurd/rating.guard';
import { ForgotPassComponent } from './pages/forgot-pass/forgot-pass.component';
import { LoginComponent } from './pages/login/login.component';
import { ReportComponent } from './pages/report/report.component';
import { ValidationComponent } from './pages/validation/validation.component';
import { VinInformationComponent } from './pages/vin-information/vin-information.component';
import { Report2Component } from './pages/report2/report2.component';
import { ConnectivityTestComponent } from './components/connectivity-test/connectivity-test.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent,
    children: [
      {
        path: 'login',
        pathMatch: 'prefix',
        redirectTo: '',
      },
    ],
  },
  {
    path: 'forgot-password',
    component: ForgotPassComponent,
  },
  {
    path: 'vin-information',
    canActivate: [AuthGuard],
    component: VinInformationComponent,
  },
  {
    path: 'connectivity-test',
    canActivate: [AuthGuard],
    component: ConnectivityTestComponent,
  },
  {
    path: 'validation',
    canActivate: [AuthGuard],
    component: ValidationComponent,
  },
  {
    //Importing the children module to load the components under Vam Module
    path: 'vam',
    loadChildren: () =>
      import('./pages/vam/vam.module').then((m) => m.VamModule),
    // canActivate: [AuthGuard],
  },
  {
    path: 'report',
    component: ReportComponent,
    // canActivate: [AuthGuard, RatingBodyType],
  },
  {
    path: 'report2',
    component: Report2Component,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
